export default __webpack_public_path__ + "static/media/icon-discord.3a10e546.svg";